import {
  GridColumnsState,
  GridColumnVisibilityModel,
} from '@mui/x-data-grid-pro'
import { Column } from '../typings'
import { State } from './typings'

type InitArgs = {
  lockedColumns: string[]
  defaultColumns: string[]
  internalColumns: GridColumnsState
  defaultVisibility: GridColumnVisibilityModel
}

export function init(args: InitArgs): State {
  const {
    lockedColumns,
    defaultColumns,
    defaultVisibility,
    internalColumns: { orderedFields: all, lookup, columnVisibilityModel: cvm },
  } = args

  const columns: Column[] = all.map((field) => {
    const label = lookup[field].headerName ?? field
    const disabled = lockedColumns.includes(field)
    const checked = disabled || cvm[field] === undefined ? true : cvm[field]

    return {
      field,
      label,
      checked,
      disabled,
    }
  })

  return {
    defaultColumns,
    defaultVisibility,
    columns: [...columns].sort((a, b) => a.label.localeCompare(b.label)),
    sortedColumns: columns.filter((c) => c.checked),
  }
}
